.b8{overflow:hidden;}